import { useTheme } from '@mui/material';

import { useMatchQuery } from './useMatchQuery';

/**
 * Пользовательский хук, который определяет, является ли текущий размер экрана размером десктопа.
 *
 * @returns {boolean} - Возвращает true, если размер экрана 'md' или больше, иначе false.
 */

export const useIsDesktop = () => {
  const theme = useTheme();

  return useMatchQuery(theme.breakpoints.up('md'));
};
